<div
  class="hero-section-box yellow-primary-background rounded-5 d-flex flex-column align-items-center justify-content-center gap-lg-4"
>
  <p class="prix-marche fw-semibold px-3 text-center lh-sm m-0">
    Accédez au vrai prix du marché
  </p>
  <p class="reference text-center fw-semibold lh-sm m-0">
    Consultez les dernières références de ventes immobilières
  </p>
  <a
    href="#contact-section"
    id="btn_landing_learn_more_cta"
    class="btn btn-lg btn-primary-landing-black bg-black rounded-bottom-start-50 rounded-top-end-50 rounded-top-start-0 rounded-bottom-end-0 px-4 py-2 text-white btn-text-size"
    >En savoir plus
    <img class="px-2" src="assets/perval-icons/arrow-right-circle.svg"
  /></a>
</div>
